var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditGoalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.499 9.716) scale(0.9298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1032 0.710145H2.79748C2.24389 0.710145 1.71296 0.93006 1.32151 1.32151C0.93006 1.71296 0.710145 2.24389 0.710145 2.79748V17.4089C0.710145 17.9624 0.93006 18.4934 1.32151 18.8848C1.71296 19.2763 2.24389 19.4962 2.79748 19.4962H17.4089C17.9624 19.4962 18.4934 19.2763 18.8848 18.8848C19.2763 18.4934 19.4962 17.9624 19.4962 17.4089V10.1032",
    stroke: "#4D4D4D",
    strokeWidth: 1.42029,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.763 7.499) scale(0.9121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6687 1.3586C12.0839 0.9434 12.647 0.710145 13.2342 0.710145C13.8214 0.710145 14.3845 0.9434 14.7997 1.3586C15.2149 1.7738 15.4481 2.33692 15.4481 2.9241C15.4481 3.51128 15.2149 4.07441 14.7997 4.4896L4.88484 14.4045L0.71016 15.4481L1.75383 11.2735L11.6687 1.3586Z",
    stroke: "#4D4D4D",
    strokeWidth: 1.42029,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGoalIcon);
export default __webpack_public_path__ + "static/media/edit_goal_icon.b8c153fd.svg";
export { ForwardRef as ReactComponent };